import { Sidebar } from "../organisms/Sidebar";
import { Navbar } from "../organisms/Navbar";

export const MainLayout = ({ children }) => {
  return (
    <div className={"min-h-screen flex flex-col"}>
      <Navbar />
      <div className={"flex flex-grow h-full"}>
        <Sidebar />
        <div className="flex-grow overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};
